export default {
  "content": "<path d=\"M10.692 16.616c0-2.904.78-5.04 2.616-6.9H9V8h6.36v1.716c-2.184 2.148-2.628 4.128-2.628 6.9h-2.04z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.929 4.928c3.905-3.905 10.237-3.905 14.142 0 3.905 3.906 3.905 10.238 0 14.143-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.906-10.237 0-14.143zm12.728 1.415A8.001 8.001 0 106.343 17.659 8.001 8.001 0 0017.657 6.343z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};